<template>
    <div>
        <div class="row">
            <div class="col-xl-9">
                <b-card no-body>
                    <b-table id="itemTable" striped sort-icon-left show-empty empty-text="There are no matching items to show" :items="this.itemsInType()" :per-page="perPage" :current-page="currentPage" :fields="fields">
                        <template v-slot:head(selected)>
                            Select
                        </template>
                        <template v-slot:head(subcategory)>
                            {{ subcategoryLabel }}
                        </template>
                        <template v-slot:head(category)>
                            {{ categoryLabel }}
                        </template>
                        <template v-slot:cell(selected)="{ item }">
                            <b-form-radio size="lg" :value="item" v-model="selectedItem" @change="itemCheck" />
                        </template>
                        <template v-slot:cell(image)="{ item }">
                            <img :src="getImage(item.image)" width="100px" />
                        </template>
                        <template v-slot:cell(subcategory)="{ item }">
                            {{ categoryName(item.category) }}
                        </template>
                        <template v-slot:cell(category)="{ item }">
                            {{ categoryParent(item.category) }}
                        </template>
                        <template v-slot:cell(inUse)="{ item }">
                            {{ checkUsage(item.id) }} {{ item.unit }}
                        </template>
                        <template v-slot:cell(amount)="{ item }">
                            {{ item.amount }} {{ item.unit }}
                        </template>
                        <template v-slot:cell(actions)="{ item }">
                            <url-button label="View details" :url="`/eventbank/${$route.params.type}/items/` + item.id" class="btn-yellow" />
                        </template>
                    </b-table>
                </b-card>
            </div>
            <div class="col-xl-3">
                <div>
                    <div role="tablist">
                        <b-card no-body class="p-0">
                            <b-card-header header-tag="header" class="p-0" role="tab">
                                <b-button block v-b-toggle.tab1 variant="light">Filters</b-button>
                            </b-card-header>
                            <b-collapse id="tab1" visible role="tabpanel">
                                <b-card-body>
                                    <label class="width-full"><b>Search:</b>
                                        <input v-model="search" placeholder="Search item" type="search" class="form-control form-control-sm" />
                                    </label>
                                    <label class="width-full"><b>Uncategorized items:</b>
                                        <b-form-checkbox switch v-model="onlyUncategorizedItems">Only uncategorized items</b-form-checkbox>
                                    </label>
                                    <label class="width-full"><b>{{ categoryFilterLabel }}</b>
                                        <select v-model="categoryFilter" class="form-control form-control-sm" @change="subcategoryFilter = 'all'">
                                            <option value="all" selected>All</option>
                                            <option v-for="category in this.parentCategories()" :key="category.id" :value="category.id">{{ category.name }}</option>
                                        </select>
                                    </label>
                                    <label class="width-full"><b>{{ subcategoryFilterLabel }}</b>
                                        <select v-model="subcategoryFilter" class="form-control form-control-sm">
                                            <option value="all" selected>All</option>
                                            <option v-for="category in this.subcategories()" :key="category.id" :value="category.id">{{ category.name }}</option>
                                        </select>
                                    </label>
                                    <label class="width-full"><b>Source:</b>
                                        <select v-model="source" class="form-control form-control-sm">
                                            <option value="All" selected>All</option>
                                            <option value="None">None</option>
                                            <option value="Owned">Owned</option>
                                            <option value="Contract">Contract</option>
                                            <option value="Other">Other</option>
                                        </select>
                                    </label>
                                    <label class="width-full"><b>Planning status:</b>
                                        <select v-model="status" class="form-control form-control-sm">
                                            <option value="all" selected>All</option>
                                            <option value="true">In use</option>
                                            <option value="false">Inactive</option>
                                        </select>
                                    </label>
                                    <input-button type="button" @click="resetFilters" label="Reset filters" class="btn-secondary mt-2" />
                                </b-card-body>
                            </b-collapse>
                        </b-card>
                    </div>
                    <div class="text-right">
                        <input-button type="button" @click="showCreateModal" label="Create new item" class="btn-yellow mt-2" />
                    </div>
                </div>
            </div>
        </div>

        <div class="row m-t-10">
            <div class="col-6">
                <label>
                    <b>Per page</b>
                    <b-form-select v-model="perPage" :options="perPageOptions" />
                </label>
            </div>
            <b-pagination class="col-6 pagination" next-class="{ background-color: red; }" align="right" v-model="currentPage" :total-rows="rows" :per-page="perPage" aria-controls="itemTable" />    
        </div>

        <b-modal ref="itemCreateModal" size="lg" hide-header hide-footer>
            <item-create 
                :typeId="currentTypeId"
                :categories="categories"
                :activeEvent="activeEvent"
                :createItemCall="createItem"
                :removeImage="removeImage"
                :removeFile="removeFile"
                :modalMode="true"
            />
        </b-modal>
    </div>
</template>

<script>
import UrlButton from '../buttons/UrlButton.vue'
import InputButton from '../buttons/InputButton.vue'
import ItemCreate from '../event-bank/ItemCreate.vue'

export default {
    name: 'ItemTable',
    props: ['items', 'categories', 'scriptItems', 'setActiveItem', 'activeItem', 'activeEvent', 'createItemCall', 'removeImage', 'removeFile'],
    components: {
        UrlButton,
        InputButton,
        ItemCreate,
    },
    data() {
        return {
            subcategoryLabel: 'Area',
            categoryLabel: 'Venue',
            servicesCheck: false,
            spacesCheck: false,
            staffCheck: false,
            stuffCheck: false,
            selectedItems: [],
            selectedItem: null,
            categoryFilterLabel: 'Venue:',
            subcategoryFilterLabel: 'Area:',
            categoryFilter: 'all',
            subcategoryFilter: 'all',
            source: 'All',
            status: 'all',
            search: '',
            onlyUncategorizedItems: false,
            action: 'add',
            modal: false,
            index: 0,
            currentItem: null,
            categoryId: 0,
            perPageOptions: [ 5, 10, 25, 50, 100 ],
            perPage: 10,
            currentPage: 1,
            fields: [
                { key: 'selected', sortable: false },
                //{ key: 'image', sortable: false },
                { key: 'name', sortable: true },
                { key: 'subcategory', sortable: true },
                { key: 'category', sortable: true },
                { key: 'amount', label: 'Total', sortable: true },
                { key: 'inUse', label: 'In use', sortable: true },
                { key: 'source', sortable: true },
                //{ key: 'actions', sortable: false }
            ],
            currentTypeId: 1,
        }
    },
    computed: {
        rows() {
            return this.itemsInType().length;
        }
    },
    filters: {
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    },
    methods: {
        createItem(itemData) {
            console.log(itemData)
            this.createItemCall(itemData);
            this.$refs['itemCreateModal'].hide();
        },
        showCreateModal() {
            this.$refs['itemCreateModal'].show();
        },
        getImage(image) {
            if (image == null) {
                return require('../../assets/images/no_image.jpg');
            } else {
                return process.env.VUE_APP_API_URL + '/uploads/images/' + image.imageFd;
            }
        },
        getUsage(currentItemId) {
            let usageString = "Not in use.";
            this.scriptItems.forEach(scriptItem => {
                if (scriptItem.amount > 0 && currentItemId == scriptItem.item.id) {
                    if (usageString == 'Not in use.') {
                        usageString = scriptItem.amount + " in " + scriptItem.step.name;
                    } else {
                        usageString += ", " + scriptItem.amount + " in " + scriptItem.step.name;
                    }
                }
            });
            return usageString;
        },
        fileType(path) {
           return path.slice(path.lastIndexOf('.') + 1);
        },
        itemsInType() {
            let self = this;
            let type = this.$route.params.type;
            let typeId = 1;
            switch (type) {
                case 'service':
                    typeId = 1;
                    break;
                case 'space':
                    typeId = 2;
                    break;
                case 'staff':
                    typeId = 3;
                    break;
                case 'stuff':
                    typeId = 4;
                    break;
                default:
                    typeId = 1;
                    break;
            }
            return this.items.filter(function (item) {
                if (item.type.id == typeId) {
                    if (item.category == null) {
                        if (self.categoryFilter == "all") {
                            if (item.name.toLowerCase().includes(self.search.toLowerCase())) {
                                return item;
                            }
                        }
                    } else if (!self.onlyUncategorizedItems && (item.category.parent == self.categoryFilter || self.categoryFilter == "all")) {
                        if (item.category.id == self.subcategoryFilter || self.subcategoryFilter == "all") {
                            if (item.source == self.source || self.source == "All") {
                                let sItem = self.scriptItems.find(scriptItem => scriptItem.item.id == item.id);
                                if (sItem && (sItem.amount > 0 && self.status == "true")) {
                                    if (item.name.toLowerCase().includes(self.search.toLowerCase())) {
                                        return item;
                                    }
                                } else if (sItem == null && self.status == "false") {
                                    if (item.name.toLowerCase().includes(self.search.toLowerCase())) {
                                        return item;
                                    }
                                } else if (self.status == "all") {
                                    if (item.name.toLowerCase().includes(self.search.toLowerCase())) {
                                        return item;
                                    }
                                }
                            }
                        }
                    }
                }
            })
        },
        parentCategories() {
            let matchingCategories = [];
            let type = this.$route.params.type;
            let typeId = 1;
            switch (type) {
                case 'service':
                    typeId = 1;
                    break;
                case 'space':
                    typeId = 2;
                    break;
                case 'staff':
                    typeId = 3;
                    break;
                case 'stuff':
                    typeId = 4;
                    break;
                default:
                    typeId = 1;
                    break;
            }
            this.categories.filter(function (category) {
                if (category.type.id == typeId && category.parent == null) {
                    matchingCategories.push(category);
                }
            });
            return matchingCategories;
        },
        setTypeId() {
            let type = this.$route.params.type;
            switch (type) {
                case 'service':
                    this.currentTypeId = 1;
                    break;
                case 'space':
                    this.currentTypeId = 2;
                    break;
                case 'staff':
                    this.currentTypeId = 3;
                    break;
                case 'stuff':
                    this.currentTypeId = 4;
                    break;
                default:
                    break;
            }
        },
        subcategories() {
            let subcategoriesInType = [];
            let parentCategory = this.categoryFilter;
            if (parentCategory != "all") {
                this.categories.forEach(category => {
                    if (category.parent) {
                        if (category.parent.id == parentCategory) {
                            subcategoriesInType.push(category);
                        }
                    }
                });
            }
            return subcategoriesInType;
        },
        categoryName(currentCategory) {
            if (currentCategory) {
                return currentCategory.name;
            } else {
                return '';
            }
        },
        categoryParent(currentCategory) {
            if (currentCategory) {
                let parentName = '';
                this.categories.forEach(category => {
                    if (category.id == currentCategory.parent) {
                        parentName = category.name;
                    }
                });
                return parentName;
            } else {
                return '';
            }
        },
        checkUsage(currentItemId) {
            let amountInUse = 0;
            this.scriptItems.forEach(scriptItem => {
                if (currentItemId == scriptItem.item.id) {
                    amountInUse += scriptItem.amount;
                }
            });
            return amountInUse;
        },
        resetFilters() {
            this.search = '';
            this.categoryFilter = "all";
            this.subcategoryFilter = "all";
            this.source = "All";
            this.status = "all";
            this.onlyUncategorizedItems = false;
        },
        itemCheck(checked) {
            this.selectedItem = checked;
            this.setActiveItem(checked, false);
        },
        unselect(index) {
            let type = this.selectedItems[index].category.type;
            switch (type) {
                case 1:
                    this.servicesCheck = false;
                    break;
                case 2:
                    this.spacesCheck = false;
                    break;
                case 3:
                    this.staffCheck = false;
                    break;
                case 4:
                    this.stuffCheck = false;
                    break;
                default:
                    break;
            }
            this.selectedItems.splice(index, 1);
        },
        unselectAll() {
            this.selectedItems = [];
            this.selectedItem = null;
        },
        updateLabels() {
            switch (this.$route.params.type) {
                case 'space':
                    this.subcategoryLabel = "Area";
                    this.categoryLabel = "Venue";
                    this.categoryFilterLabel = "Venue:";
                    this.subcategoryFilterLabel = "Area:";
                    break;
                case 'stuff':
                    this.subcategoryLabel = "Subcategory";
                    this.categoryLabel = "Category";
                    this.categoryFilterLabel = "Category:";
                    this.subcategoryFilterLabel = "Subcategory:";
                    break;
                case 'staff':
                    this.subcategoryLabel = "Team";
                    this.categoryLabel = "Group";
                    this.categoryFilterLabel = "Group:";
                    this.subcategoryFilterLabel = "Team:";
                    break;
                case 'service':
                    this.subcategoryLabel = "Area";
                    this.categoryLabel = "Category";
                    this.categoryFilterLabel = "Category:";
                    this.subcategoryFilterLabel = "Area:";
                    break;
                default:
                    break;
            }
        },
    },
    watch: {
        $route () {
            this.resetFilters();
            this.updateLabels();
            this.unselectAll();
            this.setTypeId();
        },
        activeItem () {
            if (this.selectedItem && this.activeItem && this.selectedItem.id != this.activeItem.id || !this.activeItem) {
                this.selectedItem = null;
            }
            
        }
    },
    mounted() {
        this.updateLabels();
        this.setTypeId();
    }
}
</script>